import { NavItem } from '../../../types/appModels';
import Container from '../../Common/Container/Container';
import {
  Alignment,
  Display,
  DisplayFlexDirection,
  Spacing,
} from '../../../types/appTypes';
import NavigationItem from '../NavigationItem/NavigationItem';
import styles from './NavigationList.module.css';
import { useHoneycombLayout } from '../../../hooks/useHoneycombLayout';

type NavigationListProps = {
  navItems: NavItem[];
};

const NavigationList = ({ navItems }: NavigationListProps) => {
  const itemPositions = useHoneycombLayout(navItems.length);

  if (navItems.length === 0) {
    return <></>;
  }

  return (
    <Container
      alignment={Alignment.Center}
      margin={[Spacing.Auto]}
      display={Display.Flex}
      flexDirection={DisplayFlexDirection.Row}
      secondaryClass={styles.honeycombContainer}
    >
      {navItems.map((item, index) => (
        <div key={index} style={itemPositions[index]}>
          <NavigationItem navItem={item} />
        </div>
      ))}
    </Container>
  );
};

export default NavigationList;